<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher()
    export let enable = false;
    export let disableUserControl = false;
    let inputClass = '';
    /* $:{
        dispatch('change', {
			value: enable
		});
    } */
    $: {
        dispatch('change', enable);
    }
    $: {
        if (disableUserControl) {
            inputClass = 'disableControl';
        } else {
            inputClass = '';
        }
    }
</script>

<div class="checkbox">
    {#if enable}
        <span class="material-icons"> done </span>
    {/if}
    <input type="checkbox"  class={inputClass} bind:checked={enable}  name="enable" />
</div>

<style>
    .checkbox {
    display: inline-grid;
    width: 1em;
    height: 1em;
    border-radius: 20%;
    border: 1px solid var(--prim);
    background: #eee;
    z-index: 10;
}
.checkbox input {
    position: absolute;
    opacity: 0;
    margin-bottom: 0;
    width: 1em;
    height: 1em;
}
.checkbox > .material-icons {
    font-size: 1em;
    font-weight: bold;
    color: var(--prim);
}
    
    .disableControl {
        pointer-events: none;
    }
</style>